import { render, staticRenderFns } from "./Testo.vue?vue&type=template&id=2ddb46bb&"
import script from "./Testo.vue?vue&type=script&lang=js&"
export * from "./Testo.vue?vue&type=script&lang=js&"
import style0 from "./Testo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports